(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('td-announcement')) {
    class TdAnnouncement extends HTMLElement {
      connectedCallback() {
        this.slides = Array.from(this.querySelectorAll('.td-ann__slide'));
        this.index = 0;
        if (this.slides.length < 2) return;
        this.speed = (parseFloat(this.dataset.speed) || 5) * 1000;
        this.autoplay = this.dataset.autoplay === 'true' && !window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.querySelectorAll('.td-ann__arrow').forEach((btn) =>
          btn.addEventListener('click', () => {
            this.go(this.index + parseInt(btn.dataset.dir, 10));
            this.restart();
          })
        );
        ['mouseenter', 'focusin'].forEach((e) => this.addEventListener(e, () => this.stop()));
        ['mouseleave', 'focusout'].forEach((e) => this.addEventListener(e, () => this.restart()));
        this.restart();
        document.addEventListener('shopify:block:select', (event) => {
          const i = this.slides.indexOf(event.target);
          if (i > -1) {
            this.stop();
            this.go(i);
          }
        });
      }

      go(i) {
        const n = this.slides.length;
        this.index = (i + n) % n;
        this.slides.forEach((slide, idx) => {
          const active = idx === this.index;
          slide.classList.toggle('is-active', active);
          slide.toggleAttribute('aria-hidden', !active);
          slide.querySelectorAll('a').forEach((a) => (active ? a.removeAttribute('tabindex') : a.setAttribute('tabindex', '-1')));
        });
      }

      stop() {
        clearInterval(this.timer);
      }

      restart() {
        this.stop();
        if (this.autoplay) this.timer = setInterval(() => this.go(this.index + 1), this.speed);
      }
    }
    customElements.define('td-announcement', TdAnnouncement);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  (function () {
    const mq = window.matchMedia('(max-width: 767px)');
    const sync = () => {
      document.querySelectorAll('[data-td-footer-acc]').forEach((d) => {
        if (mq.matches) {
          if (!d.dataset.touched) d.removeAttribute('open');
        } else {
          d.setAttribute('open', '');
        }
      });
    };
    document.addEventListener('click', (e) => {
      const summary = e.target.closest('[data-td-footer-acc] > summary');
      if (!summary) return;
      if (!mq.matches) {
        e.preventDefault();
        return;
      }
      summary.parentElement.dataset.touched = 'true';
    });
    mq.addEventListener('change', sync);
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', sync);
    } else {
      sync();
    }
    document.addEventListener('shopify:section:load', sync);
  })();

  } catch(e) { console.error(e); }
})();
})();
